import { uniq } from '../../shared/uniq';
import { IAggFuncParams } from 'ag-grid-community';

interface UniqListAggFuncParams extends IAggFuncParams {
  values: string[]
}

export const uniqListAggregation = ({ values }: UniqListAggFuncParams) => uniq(values).join(',');
